import {Form} from '../../../../stores/Form';
import {getAllRecordsCount} from '../form';

export const updateAllRecordsCount = async (
    form: Form,
    fetchedRecordsCount: number,
    options: {
        top: number;
        skip: number;
    }
) => {
    const {top, skip} = options;
    if (!skip && fetchedRecordsCount < top) {
        form.setAllRecordsCount(fetchedRecordsCount);
    } else {
        await getAllRecordsCount(form);
    }
};
